import React, { useState, useEffect } from 'react';

const StoreInventoryDisclaimer = (props) => {
  return (
    <div className="StoreInventoryDisclaimer" data-inventory-disclaimer-msg>
      <span className="StoreInventoryDisclaimer__message">
        Product availability changes frequently and isn’t guaranteed.
      </span>
    </div>
  );
};

export default StoreInventoryDisclaimer;
